"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);









const getAuditLogFiltersActions = _utils.createAsyncActions('GetAuditLogFilters')
const listAuditEventsActions = _utils.createAsyncActions('ListAuditEvents')
const getPatientAccessHistoryActions = _utils.createAsyncActions('GetPatientAccessHistory')
const exportAuditLogActions = _utils.createAsyncActions('ExportAuditLog')

 const actionCreators = {
  getAuditLogFiltersActions,
  listAuditEventsActions,
  getPatientAccessHistoryActions,
  exportAuditLogActions,
}; exports.actionCreators = actionCreators

exports. default = {
  getAuditLogFilters: (req) =>
    _helpers.wsCommand('GetAuditLogFilters', getAuditLogFiltersActions, req, null),
  listAuditEvents: (req) =>
    _helpers.wsCommand('ListAuditEvents', listAuditEventsActions, req, null),
  getPatientAccessHistory: (req) =>
    _helpers.wsCommand('GetPatientAccessHistory', getPatientAccessHistoryActions, req, null),
  exportAuditLog: (req) =>
    _helpers.wsCommand('ExportAuditLog', exportAuditLogActions, req, null)
      .then(r => _client2.default.getFileLink(r.FileKey).then(l => ({ FileName: r.FileName, URL: l.Link, Rows: r.Rows }))),
}
